import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

interface ItemContainerProps {
  margin?: number
}

export const Title = styled.span`
  color: #999999;
  font-size: 14px;
  line-height: 140%;
`
export const Subtitle = styled.span`
  color: #000000;
  font-size: 16px;
  font-weight: 900;
  line-height: 140%;
  text-transform: capitalize;
`

export const ItemContainer = styled.div<ItemContainerProps>`
  margin-bottom: ${props => (props.margin ? props.margin : 15)}px;
`

export const GridCard = styled.div`
  position: relative;

  .card-height {
    max-height: 280px !important;
    display: block;
  }

  .card-button-mt {
    margin-top: 14px !important;
  }

  .card-button {
    background: ${colors.green};
    color: white;
    margin-top: 8px;
    height: 37px !important;

    .MuiButton-startIcon {
      margin-top: -3px;
    }

    .MuiButton-label {
      text-transform: none;
    }

    :hover {
      background: ${colors.greenDark};
    }
  }

  @media screen and (max-height: 900px) {
    .card-height {
      height: 250px !important;
      padding: 18px 16px;
    }
  }
`
